import createToken, { TokenParams } from './createToken/createToken'
import translatorModule from '../../i18n'
import getBaseUrl from '../../../../utils/getBaseUrl/getBaseUrl'
import {
  getCopyParams,
  getLocale,
  getMacros,
  interpolateMacros,
} from '../utils'
import GkdAuthParams from '../../../../types/GkdAuthParams'

const CUSTOM_TOKEN_HEADER = 'x-klarna-osm-token'

export default async function initTranslations(
  params: TokenParams,
  gkdAuthParams: GkdAuthParams
) {
  const locale = getLocale(params)
  const translationModule = await import(`../translations/${locale}.json`)
  const translation = translationModule.default
  const v4MacroUrl = `${params.adServerUrl}/v4/macros/values`
  const v3MacroUrl = `${params.adServerUrl}/v3/macros/values`
  let authHeaderValue
  let integratorOriginHeaderValue
  let accountId

  if (gkdAuthParams) {
    authHeaderValue = gkdAuthParams.clientId
    integratorOriginHeaderValue = gkdAuthParams.integratorOrigin
    accountId = gkdAuthParams.accountId
  }

  // @ts-ignore
  const translator = translatorModule(translation)
  // eslint-disable-next-line no-param-reassign
  params.adServerUrl = params.adServerUrl || getBaseUrl(locale) || process.env.CMA_BASE_URL

  const { copyParams, nonAmountBasedPath } = getCopyParams(params)
  const getCopy = translator.getPartial
  const rawCopy = getCopy(...copyParams)
  let copy = null
  // Generic error is displayed when there is not both amount and non-amount based copy
  let error: null | Error = null
  const copyMacros = getMacros(rawCopy as object)

  function useNonAmountBased() {
    try {
      copy = getCopy(nonAmountBasedPath)
      // @ts-ignore
      if (copy.default_values) {
        // @ts-ignore
        copy = interpolateMacros(rawCopy, copy.default_values)
      }
    } catch (err: any) {
      error = err
    }
  }

  if (copyMacros.length > 0) {
    try {
      const token = createToken(params, copyMacros)

      let url = v3MacroUrl
      const headers = {
        'Content-Type': 'application/x-www-form-urlencoded',
        [CUSTOM_TOKEN_HEADER]: token,
      }

      if (authHeaderValue && integratorOriginHeaderValue) {
        url = v4MacroUrl
        headers['Authorization'] = `basic ${authHeaderValue}`
        headers['Klarna-Integrator-Origin'] = integratorOriginHeaderValue
        if (accountId) headers['Klarna-Account'] = accountId
      }

      const res = await fetch(url, {
        method: 'GET',
        headers,
      })

      if (!res.ok) throw new Error('Failed to fetch macros')

      const macros = await res.json()
      copy = interpolateMacros(rawCopy, macros)
    } catch (e: any) {
      useNonAmountBased()
    }
  } else {
    copy = rawCopy
  }

  return { translator, copy, error }
}
